//basic
import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../../functions/api';

//custom components
import CustomInput from '../../../components/basic/input';
import CustomButton from '../../../components/basic/CustomButton';

//material-ui
import { Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, MenuItem, Select, Button, CircularProgress, ListItem } from '@material-ui/core';

//style
import './AddEditParameter.scss';
import SelectSearch from "../../../components/basic/SelectSearch/SelectSearch";
import CustomAvatar from "../../../components/basic/customAvatar";
import image from "../../../assets/image/svg/logo.svg";

@inject('translate')
@inject('internal')
@observer
export default class AddEditParameter extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            parameter_type_id: 1,
            loading: false,
            loadingBtn: false,
            production: false,
            image: image
        }
    }

    componentDidMount () {
        let isEditMode = toJS(this.props.internal.actionEdit);
        if(isEditMode.edit) {
            this.setState({loading: true});
            this.loadDetailParameter(isEditMode.id)
        }
    }


    loadDetailParameter = async(id) => {
        let load_data = await api({
            method:'get',
            url: `lists/parameters/${id}`,
            authorization: this.props.internal.user.access_token,
            params:{

            }
        })

        if(load_data.success === true) {
            this.setState({
                loading: false,
                parameter_type_id: load_data.data.data.parameter_type_id,
                production: load_data.data.data.production,
                image: load_data.data.data.image ? load_data.data.data.image : image
            })
            this.title_frontend.setValue(load_data.data.data.external_name);
            this.title_backend.setValue(load_data.data.data.internal_name);
            this.description.setValue(load_data.data.data.description);
        }

    }

    handleChangeParameterType = (event) => {
        this.setState({parameter_type_id: event.target.value})
    }

    handleChangeProduction = (event) => {
        this.setState({production: event.target.checked})
    }

    action = () => {
        if(this.title_backend.state.value === "" || this.title_frontend.state.value === "") {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
        }
        else {
            this.updateCreateParameter()
        }
    }

    updateCreateParameter = async() => {
        this.setState({loadingBtn: true})
        let isEditMode = toJS(this.props.internal.actionEdit);

        let url = "lists/parameters";
        let method = "post";
        if(isEditMode.edit) {
            url += `/${isEditMode.id}`;
            method = 'patch'
        }

        let update_data = await api({
            method: method,
            url: url,
            authorization: this.props.internal.user.access_token,
            params:{
                internal_name: this.title_backend.state.value,
                external_name: this.title_frontend.state.value,
                parameter_type_id: this.state.parameter_type_id,
                production: this.state.production,
                description: this.description.state.value,
            }
        })

        if((update_data.success === false && update_data.status === 201) || update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true);
            this.props.onClose();
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true);
        }
        this.setState({loadingBtn: false})
    }

    handleChangePhoto = async (data) => {
        let idParameter = toJS(this.props.internal.actionEdit.id)

        if (idParameter !== null) {
            this.setState({ loadingBtn: true })
            let upload_data = await api({
                method: 'post',
                url: `lists/parameters/${idParameter}`,
                formData: true,
                authorization: this.props.internal.user.access_token,
                params: {
                    image: data
                },

            })
            
            if (upload_data.success && upload_data.success === true) {
                // this.props.internal.photoWasChanged(false)
                this.props.internal.setSnackbar(upload_data.data.message, true)
                this.setState({ loadingBtn: false })
                return Promise.resolve(false)
            }
            else {
                this.props.internal.setSnackbar(upload_data.data.message, true)
            }
            
        }
        else {

        }
    };

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
                classes={{
                    paper: "addEditParameterDialog"
                }}
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                {this.state.loading
                    ?
                    <CircularProgress className={'circular-progress'}/>
                    :
                    <div>
                    <div className={'flex-center'}>
                        <CustomAvatar
                            src={this.state.image}
                            actionUploadPhoto={this.handleChangePhoto}
                        />
                    </div>
                    <CustomInput
                        ref={ref => this.title_frontend = ref}
                        text={this.props.translate.i18n.MODULES.PARAMETERS.TITLE_FRONTEND}
                        // value={this.props.idCategory ? this.editCategory.name : ""}
                        id={'title_frontend'}
                        className={"w-100"}
                        required
                    />
                    <CustomInput
                        ref={ref => this.title_backend = ref}
                        text={this.props.translate.i18n.MODULES.PARAMETERS.TITLE_BACKEND}
                        // value={this.props.idCategory ? this.editCategory.name : ""}
                        id={'title_backend'}
                        className={"w-100"}
                        required
                    />

                    <CustomInput
                        ref={ref => this.description = ref}
                        text={this.props.translate.i18n.MODULES.PARAMETERS.DESCRIPTION}
                        value={this.props.description}
                        id={'parameterDescription'}
                        className={"stretch mb-10"}
                        italic
                        multiline={true}
                    />
                    <FormControl className='parameter-type-selector w-100'>
                        <InputLabel className={'parameter-type-label'}>{this.props.translate.i18n.MODULES.PARAMETERS.CHOSE_PARAMETER_TYPE}</InputLabel>
                        <Select
                            className={'select-param-type'}
                            fullWidth
                            onChange={this.handleChangeParameterType}
                            value={this.state.parameter_type_id}

                        >
                            <MenuItem value={1}>{this.props.translate.i18n.MODULES.PARAMETERS.PARAMETER_TYPES.ONE_PARAM}</MenuItem>
                            <MenuItem value={2}>{this.props.translate.i18n.MODULES.PARAMETERS.PARAMETER_TYPES.MULTIPLE_PARAMS}</MenuItem>
                            <MenuItem value={3}>{this.props.translate.i18n.MODULES.PARAMETERS.PARAMETER_TYPES.TEXT_PARAM}</MenuItem>
                        </Select>
                    </FormControl>
                    <ListItem
                        dense
                        onChange={this.handleChangeProduction}
                        className={"list-item"}
                    >
                        <input
                            id={"production"}
                            type="checkbox"
                            value={"production"}
                            defaultChecked={this.state.production}
                        />
                        <label htmlFor={"production"}>
                            {this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}
                        </label>
                    </ListItem>
                    </div>
                }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.action}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/parameters/AddEdit/AddEditParameter.js